module.exports = __webpack_public_path__ + "img/bp-red.0bc80a21.png";